<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    viewBox="0 0 224 224"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M182.61,54.4v115.38c0,4.38-3.45,7.51-3.97,7.51l-67.62-67.62,64.7-64.88c3.15,0,6.89,5.8,6.89,9.61Z" fill="#00c58a"/>
    <path d="M54.15,182.62c-11.77,0-12.76-10.47-12.66-17.25l34.36-34.1,51.16,51.35H54.15Z" fill="#00c58a"/>
    <path d="M124.92,41.57l-49.04,49.12s-22.92-22.92-34.09-33.77c-.2-.21-.37-.45-.4-.74-.02-.2.17-1.67.17-1.92,0-7.08,6.41-12.68,12.68-12.68,23.25-.4,46.53-.05,69.8-.18l.88.17Z" fill="#00c58a"/>
  </svg>
</template>
